import { useEffect, useState } from 'react';
import { parseLastIdentityStatusUpdate } from 'src/ui/views/dynamics/CaseGlobalViewPage/sections/CaseInformation/helpers';
export var useCaseInformation = function (props) {
    var tabs = props.tabs, information = props.information, currentApplicantId = props.currentApplicantId, currentTabIndex = props.currentTabIndex, onTabChange = props.onTabChange;
    var _a = useState(null), currentIdentity = _a[0], setCurrentIdentity = _a[1];
    var _b = useState(information[0]), infoData = _b[0], setInfoData = _b[1];
    var _c = useState({
        label: '',
        color: null,
    }), timeSinceIdentityChange = _c[0], setTimeSinceIdentityChange = _c[1];
    useEffect(function () {
        var currentTab = tabs[currentTabIndex];
        var isApplicantTab = !!(currentTab === null || currentTab === void 0 ? void 0 : currentTab.applicantId);
        if (isApplicantTab) {
            var dataApplicant = information.find(function (info) { return info.applicantId === currentApplicantId; }) ||
                information.find(function (info) { return info.applicantId === (currentTab === null || currentTab === void 0 ? void 0 : currentTab.applicantId); });
            if (dataApplicant) {
                setInfoData(dataApplicant);
                setCurrentIdentity((dataApplicant === null || dataApplicant === void 0 ? void 0 : dataApplicant.identity) || null);
            }
            return;
        }
        var infoApplicantFiltered = tabs.filter(function (info) { return !!!info.applicantId; });
        var dataApplicantFiltered = information.filter(function (info) { return !!!info.applicantId; });
        var lengthApplicantTab = tabs.length - infoApplicantFiltered.length;
        var correctedIndex = currentTabIndex - lengthApplicantTab;
        var tabData = dataApplicantFiltered[correctedIndex];
        if (tabData) {
            setCurrentIdentity(null);
            setInfoData(tabData);
        }
    }, [currentTabIndex, currentApplicantId, information]);
    useEffect(function () {
        var handleTimeChange = function () {
            setTimeSinceIdentityChange(parseLastIdentityStatusUpdate(currentIdentity === null || currentIdentity === void 0 ? void 0 : currentIdentity.lastIdentityStatusUpdateTime));
        };
        // set immediately before first interval is trigger
        setTimeSinceIdentityChange(parseLastIdentityStatusUpdate(currentIdentity === null || currentIdentity === void 0 ? void 0 : currentIdentity.lastIdentityStatusUpdateTime));
        var updateTimeSinceIdentityChange = setInterval(handleTimeChange, 2000);
        return function () { return clearInterval(updateTimeSinceIdentityChange); };
    }, [infoData, currentIdentity]);
    var handleTabChange = function (newTab) {
        var newIndex = tabs.findIndex(function (item) { return item.id === newTab.id; });
        if (newIndex !== currentTabIndex) {
            onTabChange(newIndex);
        }
    };
    return {
        currentIdentity: currentIdentity,
        infoData: infoData,
        timeSinceIdentityChange: timeSinceIdentityChange,
        handleTabChange: handleTabChange,
    };
};
